import {
  addCommas,
  digitsEnToFa,
  digitsFaToEn,
  removeCommas,
} from '@persian-tools/persian-tools';

export function formatPrice(price: string): string {
  return digitsEnToFa(addCommas(price));
}

export function resolvePrice(formattedPrice: string): number {
  return removeCommas(digitsFaToEn(formattedPrice));
}
